import { render, staticRenderFns } from "./EditComdityModal.vue?vue&type=template&id=188db128"
import script from "./EditComdityModal.vue?vue&type=script&lang=js"
export * from "./EditComdityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports